export const DATE_TIME_FORMATE = 'MM/dd/yyyy HH:mm';
export const REPORT_TIME_YEAR = 'y-MM';
export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export const DATEPICKER_FORMAT_DATE = 'd/m/Y';
export const DATEPICKER_FORMAT_DATE_TIME = 'm/d/Y H:i';
export const HOUR_MINUTE_FORMAT = 'HH:mm';
export const MONTH_DAY_FORMAT = 'MM/dd';
export const MOMENT_DATE_TIME_FORMAT = 'MM/DD/yyyy HH:mm';
